import { GetInlineHelpContentInput } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
import CarrierLogisticsWebServerClient from "../clients/CarrierLogisticsWebServerClient";
export function getInlineHelpContentService(param) {
    var pageId = param.pageId;
    return CarrierLogisticsWebServerClient.getInlineHelpContent(GetInlineHelpContentInput.clone({
        pageId: pageId
    }));
}
export default getInlineHelpContentService;

//# sourceMappingURL=inlineHelpContent.js.map